import { tokenizeMentions } from './mentionText.js';

/**
 * BOS+ Phase 14b — renders a message body, drawing structured
 * `@[Name](user:uuid)` tokens as styled `.mention-chip`s and everything else as
 * plain text. Text is rendered as React children (never dangerouslySetInnerHTML),
 * so message content is escaped and cannot inject markup.
 */
export default function MessageBody({ body }) {
  const segments = tokenizeMentions(body);
  const wrap = { whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' };
  // No tokens → render the raw string (also covers empty bodies).
  if (!segments.some((s) => s.type === 'mention')) {
    return <span style={wrap}>{body}</span>;
  }
  return (
    <span style={wrap}>
      {segments.map((s, i) =>
        s.type === 'mention' ? (
          <span key={i} className="mention-chip" data-testid="messenger-mention-chip" data-user-id={s.userId}>
            @{s.display}
          </span>
        ) : (
          <span key={i}>{s.value}</span>
        )
      )}
    </span>
  );
}
